import React from 'react';
import { Col, Divider, Row } from 'antd';
import { isEqual } from 'lodash';

import {
  WorkerHistoryDetailsModel,
  WorkerHistoryRequest,
} from 'api/adminApiClient';
import HistoryLog from '../../HistoryLog';
import HistoryField from '../../HistoryField';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: WorkerHistoryDetailsModel;
  historyId: string;
};

export default function WorkerInformationDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const hasWorkerFirstNameChanged = !isEqual(
    oldData?.firstName || '',
    newData?.firstName || '',
  );
  const hasWorkerLastNameChanged = !isEqual(
    oldData?.lastName || '',
    newData?.lastName || '',
  );
  const hasWorkerEmailChanged = !isEqual(
    oldData?.email || '',
    newData?.email || '',
  );
  const hasWorkerPhoneNumberChanged = !isEqual(
    oldData?.phoneNumber || '',
    newData?.phoneNumber || '',
  );
  const hasWorkerInformation =
    hasWorkerFirstNameChanged ||
    hasWorkerLastNameChanged ||
    hasWorkerEmailChanged ||
    hasWorkerPhoneNumberChanged;

  const renderWorkerInformation = (worker?: WorkerHistoryRequest) => {
    if (!worker) return null;

    const { firstName, lastName, email, phoneNumber } = worker;
    const sectionName = 'worker-information';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Worker information</div>
          </Col>

          {hasWorkerFirstNameChanged && (
            <HistoryField
              title="First name"
              value={firstName}
              dataId={`${sectionName}-first-name-field`}
            />
          )}

          {hasWorkerLastNameChanged && (
            <HistoryField
              title="Last name"
              value={lastName}
              dataId={`${sectionName}-last-name-field`}
            />
          )}

          {hasWorkerEmailChanged && (
            <HistoryField
              title="Email"
              value={email}
              dataId={`${sectionName}-email-field`}
            />
          )}

          {hasWorkerPhoneNumberChanged && (
            <HistoryField
              title="Phone number"
              value={phoneNumber}
              dataId={`${sectionName}-phone-number-field`}
            />
          )}
        </Row>

        <Divider />
      </>
    );
  };

  if (!hasWorkerInformation) return null;

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderWorkerInformation(oldData)}
      newData={renderWorkerInformation(newData)}
    />
  );
}
